module.exports = __webpack_public_path__ + "a9368fc4828f82f3ee40aa567691a34f.svg";